import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { Benefits } from './components/Benefits';
import { PainPoints } from './components/PainPoints';
import { Solution, Audience } from './components/Solution';
import { DigitalAccess } from './components/DigitalAccess';
import { Pricing, FinalUrgency } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Contact, Footer } from './components/Footer';
import { EmotionalClose } from './components/EmotionalClose';
import { PAGE_TITLE, PAGE_DESCRIPTION } from './data/pack';
export function App({
  showLaunchUrgency = true
}: {
  showLaunchUrgency?: boolean;
}) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', PAGE_DESCRIPTION);
  }, []);
  return <div className="min-h-screen w-full bg-brand-surface font-sans text-brand-text selection:bg-brand-goldLight/50" data-id="element-0" data-mp="5yjsutqtdfe">
      {showLaunchUrgency && <UrgencyBanner data-id="element-1" data-mp="2zm4ywnvchj3e" />}
      <Hero data-id="element-2" data-mp="2zmo5x9jgin2n" />
      <PackContents data-id="element-3" data-mp="2zn6aquk6q9m6" />
      <Benefits data-id="element-4" data-mp="33movnqc0akp0" />
      <PainPoints data-id="element-5" data-mp="33m5cy7ej7s9x" />
      <Solution data-id="element-6" data-mp="33nq4do5juv3k" />
      <Audience data-id="element-7" data-mp="33n6y54p9hv5d" />
      <Pricing data-id="element-8" data-mp="33orik1hv3xpi" />
      <DigitalAccess data-id="element-9" data-mp="38lrp0dimj2h5" />
      <Guarantee data-id="element-10" data-mp="38l8gtoirzsgb" />
      <FAQ data-id="element-11" data-mp="38kqbm2e4y3w9" />
      <CostComparison data-id="element-12" data-mp="38l00tnrcw70w" />
      <EmotionalClose data-id="element-13" data-mp="38nuqbtp88i16" />
      {showLaunchUrgency && <FinalUrgency data-id="element-14" data-mp="3dl4n5uey3vz1" />}
      <Contact data-id="element-15" data-mp="3dlns8ajhypvn" />
      <Footer data-id="element-16" data-mp="3dm5y7yvyoigr" />
    </div>;
}